
<template>
  <div class="model-content" style="display: flex; justify-content: center;">
    <div class="model3">
      <div>
        <img style="width: 100%;" :src="moban_list.img" />
      </div>
      <div class="merchant_name_items"
        :class="(posterList.lang == 'ug' || !posterList.lang) ? 'rtl merchant_name_ug' : 'merchant_name_ug  zh-font'">
        <div class="merchant_name">
          <div class="merchant_name_font">{{ posterList.merchant_name }}</div>
        </div>
      </div>
      <div class="food_name" :class="(posterList.lang == 'ug' || !posterList.lang) ? 'rtl food_name_ug' : 'food_name_ug'">
        <div class="food_name_font">{{ posterList.food_name }}</div>
      </div>
      <div class="food_img" :class="(posterList.lang == 'ug' || !posterList.lang) ? 'food_img_ug' : 'food_img_ug'">
        <img :src="posterList.food_img" alt="">
      </div>
      <div class="food_price" :class="(posterList.lang == 'ug' || !posterList.lang) ? 'food_price_ug' : 'food_price_ug'">
        <span>{{ posterList.food_price }}</span><span style="font-size: 18px;margin-top:2px">￥</span>
      </div>
      <div class="merchant_qrcode"
        :class="(posterList.lang == 'ug' || !posterList.lang) ? 'merchant_qrcode_ug' : 'merchant_qrcode_ug'">
        <img :src="posterList.merchant_qrcode" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      posterList: {},
      moban_list: {
        img: require('../../img/poster/model7.png'),
      },
    };
  },
  created() {
    this.canvasfortitle(this.$route.query.merchant_name, this.$route.query.food_name,this.$route.query)
  },
  methods: {
    canvasfortitle(merchant_name, food_names, query) {
      let res_name = merchant_name.replaceAll('(','-')
      res_name = res_name.replaceAll('（','-')
      res_name = res_name.replaceAll(')',' ')
      res_name = res_name.replaceAll('）',' ')
      let food_name = food_names.replaceAll('(','-')
      food_name = food_name.replaceAll('（','-')
      food_name = food_name.replaceAll(')',' ')
      food_name = food_name.replaceAll('）',' ')
      this.posterList = query;
      this.posterList['merchant_name'] = res_name;
      this.posterList['food_name'] = food_name;
    },
  }
};
</script>

<style scoped>
.model-content {
  width: 338.99px;
  height: 588.81px;
  position: relative;
  margin: auto;
}

.model3 {
  width: 338.99px;
  height: 588.81px;
  position: relative;
}

.merchant_qrcode {
  position: absolute;
  width: 74.81px;
  height: 74.72px;
  border-radius: 29px;
  background-color: #fff;
}

.merchant_qrcode img {
  width: 100%;
  height: 100%;
  border-radius: 29px;
}

.merchant_qrcode_ug {
  left: 38px;
  top: 488px;
}

.food_img {
  position: absolute;
  width: 165px;
  height: 165px;
  border-radius: 82.5px;
}

.food_img img {
  width: 100%;
  height: 100%;
  border-radius: 82.5px;
}

.food_img_ug {
  left: 14px;
  top: 226px;
}

.food_price {
  position: absolute;
  font-size: 28px;
  color: #16a650;
  font-weight: 600;
  width: 124px;
  height: 67px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.food_price_ug {
  right: 33px;
  top: 283px;
}


.food_name {
  position: absolute;
  color: #fffc00;
  font-weight: 600;
  width: 140px;
  height: 50px;
  justify-content: center;
  align-items: center;
  display: flex;
  z-index: 9;
  font-size: 16px;
}

.food_name_ug {
  right: 28px;
  top: 220px;
}

.food_name_font {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /*垂直排列*/
  line-clamp: 2;
  -webkit-line-clamp: 2;
  /*只显示6行*/
  overflow: hidden;
  /*溢出隐藏*/
  text-overflow: ellipsis;
  /*省略号代替*/
  text-align: center;
  line-height: 28px;
}

.merchant_name {
  max-width: 244px;
  min-width: 150px;
  height: 61px;
  border-radius: 14px;
  display: flex;
  justify-content: center;
  color: #16a650;
  font-size: 18px;
  align-items: center;
  background: white;
  padding: 0 10px;
  margin: auto;
}

.merchant_name_items {
  position: absolute;
  display: flex;
}

.merchant_name_ug {
  width: 100%;
  top: 90px;
}

.merchant_name_font {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  line-height: 26px;
  margin-top: 3px;
}
</style>